import { useState } from "react"
import { IconButton, StandardButton } from "../atoms/buttons"
import { TextAtom } from "../atoms/TextAtom"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { AvatarBackgroundButton, AvatarButton, AvatarPositionButton } from "./avatarButton"
import { ImageSelectorModalCopy } from "../components/customModals"
import { color } from "chart.js/helpers"
import { position } from "polished"

export const AvatarSelection = ({ selectedAvatar, selectAvatar, avatars}) => {
    return (
        <VerticalLayout className="avatar-selection">
            <TextAtom
                title={"Selecteer een avatar"}
                style={{"marginBottom": "0.5rem"}}
                className={"standard-text-color full-width semi-bold"}
            />

            <HorizontalLayout className="full-width standard-margin-bottom">
                {avatars.map((avatar, index) => (
                    <AvatarButton
                        isSelected={selectedAvatar.id === avatar.id}
                        onClick={(event) => { event.stopPropagation(); selectAvatar(avatar); }}
                        key={`${index} - ${avatar.id}`} avatar={avatar} />
                ))
                }
            </HorizontalLayout>
        </VerticalLayout>

    )

}
export const AvatarBackgroundSelection = ({ selectedAvatar, selectAvatar, avatarsBackgrounds, setAvatarsBackgrounds }) => {
    const [backgroundModal, setBackgroundModal] = useState(false);
    const addBackground = (selection) => {
    const newBg = {
        id_background: 3,
        colors: selection.colors,
        alt: "Custom Gradient",
    };

    setAvatarsBackgrounds((prev) => {
        if (Array.isArray(prev)) {
        return prev.map((bg) =>
            bg.id_background === 3 ? newBg : bg
        );
        }
        return [newBg];
    });

    selectAvatar(newBg);
    setBackgroundModal(false);
    };
    return (
        <VerticalLayout className="avatar-selection">
            <TextAtom
                title={"Selecteer een achtergrond"}
                style={{"marginBottom": "0.5rem"}}
                className={"standard-text-color semi-bold full-width"}
            />
            <HorizontalLayout className="full-width standard-margin-bottom">
                {avatarsBackgrounds.map((avatar, index) => (
                    <AvatarBackgroundButton
                        isSelected={selectedAvatar.id_background === avatar.id_background}
                        onClick={(event) => { event.stopPropagation(); selectAvatar(avatar); }}
                        key={`${index} - ${avatar.id}`} avatar={avatar} />
                ))}
                <VerticalLayout style={{ margin: 0, padding: "0", width:"auto", height: "6rem", justifyContent: "flex-start", alignItems: "flex-start", }}>
                    <IconButton style={{ marginLeft: "0", }} onClick={(e) => { e.stopPropagation(); setBackgroundModal(true); }} className={"avatar-background-add standard-margin-left"} size={25} icon2={"plus"} />
                </VerticalLayout>
            </HorizontalLayout>
            <ImageSelectorModalCopy type="avatar-bg" visible={backgroundModal} dismiss={() => setBackgroundModal(false)} imageSelected={addBackground} />
        </VerticalLayout>
    )
}


export const MultiSelect = ({ options, selectedOption, selectOption, createScene, showCreate = false }) => {
    return (
        <VerticalLayout className="avatar-selection">
            <TextAtom
                title={"Selecteer een lengte"}
                style={{"marginBottom": "0.5rem"}}
                className={"standard-text-color semi-bold full-width"}
            />
            <HorizontalLayout className="full-width standard-margin-bottom" style={{gap:"1rem"}}>
                {options.map((option, index) => (
                    <AvatarPositionButton
                        isSelected={selectedOption === option.id}
                        onClick={(event) => { event.stopPropagation(); selectOption(option.id); }}
                        key={`${index} - ${option.id}`} 
                        position={option} 
                    />
                ))}
            </HorizontalLayout>
       {showCreate == true && <StandardButton onClick={(event) => { event.stopPropagation();createScene()}} style={{width:"100%",justifyContent:"center", marginLeft:0, fontWeight:"bold"}} title={"Creeër scene"}/>}
        </VerticalLayout>
    )
}

export const AvatarPositionSelection = ({ selectedAvatar, selectAvatar }) => {
    const avatarsPositions = [
        { id: 1, title: "Links" },
        { id: 2, title: "Centrum" },
        { id: 3, title: "Rechts" },
    ]

    return (
        <MultiSelect 

            options={avatarsPositions}
            selectedOption={selectedAvatar}
            selectOption={selectAvatar}
            
        />
    )
}


export const LengthSelection = ({ selectedLength, selectLength, createScene }) => {
    const avatarLengths = [
        { id: 1, title: "Kort (~ 30s)" },
        { id: 2, title: "Midden (~ 1m15)" },
        { id: 3, title: "Lang (~ 2m)" },
    ]

    return (
        <MultiSelect 
            createScene={createScene}
            options={avatarLengths}
            selectedOption={selectedLength}
            selectOption={selectLength}
            showCreate={true}
        />
    )
}